export const todoItemStyle = {
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		padding: '12px 0',

		'&:not(:last-child)': {
			borderBottom: '1px solid var(--neutral-100)',
		},
	},

	content: {
		flex: '1',
	},

	description: {
		display: '-webkit-box',
		overflow: 'hidden',
		webkitLineClamp: '2',
		WebkitBoxOrient: 'vertical',
	},

	navigateIcon: {
		cursor: 'pointer',

		'svg path': {
			fill: 'var(--primary-700)',
		},
	},
};
